import React from 'react'

const LiveIconView = ({style, small}) => (
    <div style={{ paddingLeft: 2, paddingRight: 2, background: '#f15f43', borderRadius: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', ...style}}>
        <p style={{margin: 0, padding: 0, fontSize: small ? 8 : 10, color: 'white'}}>LIVE</p>
    </div>
)

export default LiveIconView;